export { TeamSearchInputRenderer as TeamSearchInput } from "./TeamSearchInputRenderer";
